import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivitiesComponent } from './activities.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../material-module';
import { SharedModule } from '../shared/shared.module';
import { ActivitiesService } from './activities.service';
import { ActivityClassBookingComponent } from './activity-class-booking/activity-class-booking.component';
import { ActivityFilterComponent } from './activity-class-booking/activity-filter/activity-filter.component';
import { ActivitySelectorComponent } from './activity-class-booking/activity-selector/activity-selector.component';
import { ActivitySlotViewComponent } from './activity-class-booking/activity-slot-view/activity-slot-view.component';
import { ActivitySummaryComponent } from './activity-summary/activity-summary.component';
import { ActivityGuestEditComponent } from './activity-summary/activity-guest-edit/activity-guest-edit.component';
import { ActivityCommonHeaderComponent } from './activity-common-header/activity-common-header/activity-common-header.component';
import { ActivitySlotSummaryComponent } from './activity-summary/activity-slot-summary/activity-slot-summary.component';
import { ActivityBookingSummaryComponent } from './activity-booking-summary/activity-booking-summary.component';
import { ActivityCommonFooterComponent } from './activity-common-footer/activity-common-footer.component';
import { SlotTimeFormatter } from '../shared/pipes/slot-time-formatter.pipe';
import { MessageComponent } from './message/message.component';
import { OpenBookingSelectorComponent } from './open-booking-selector/open-booking-selector.component';
import { ActivityBookingComponent } from './activity-booking/activity-booking.component';
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { RatePlanDetailsComponent } from './rate-plan-details/rate-plan-details.component';
import { ClassInfoComponent } from './activity-class-booking/class-info/class-info.component';
import { ActivityScheduleComponent } from './activity-class-booking/activity-schedule/activity-schedule.component';
import { OpenBookingSlotViewComponent } from './open-booking-slot-view/open-booking-slot-view.component';
import { ActivityAdditionalguestComponent } from './activity-summary/activity-additionalguest/activity-additionalguest.component';
import { CartDetailsComponent } from './cart-details/cart-details.component';
import { PrivateActivityBookingComponent } from './private-activity-booking/private-activity-booking.component';

@NgModule({
declarations: [
ActivitiesComponent,
ActivityClassBookingComponent, 
ActivityFilterComponent,
ActivitySelectorComponent,
ActivitySlotViewComponent,
ActivitySummaryComponent,
ActivityGuestEditComponent,
ActivityCommonHeaderComponent,
ActivitySlotSummaryComponent,
ActivityBookingSummaryComponent,
ActivityCommonFooterComponent,
MessageComponent, 
OpenBookingSelectorComponent, 
ActivityBookingComponent, 
RatePlanDetailsComponent, 
ClassInfoComponent, 
ActivityScheduleComponent, 
OpenBookingSlotViewComponent, 
ActivityAdditionalguestComponent, CartDetailsComponent, PrivateActivityBookingComponent],
imports: [
CommonModule,
TranslateModule,
FormsModule,
MaterialModule,
SharedModule,
// OwlDateTimeModule, OwlNativeDateTimeModule

],
providers: [ActivitiesService, SlotTimeFormatter]
})
export class ActivitiesModule { }
